import { render, staticRenderFns } from "./e-dialog.vue?vue&type=template&id=bd478420"
import script from "./e-dialog.vue?vue&type=script&lang=js"
export * from "./e-dialog.vue?vue&type=script&lang=js"
import style0 from "./e-dialog.vue?vue&type=style&index=0&id=bd478420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports